import {ErrorObject} from "../types";
import axios, {AxiosError, AxiosResponse} from "axios";

export type FeedbackMessageType = 'idea' | 'thanks' | 'question';

export interface FeedbackValues {
  email: string;
  message: string;
  messageType: FeedbackMessageType;
}

/**
 * send landing feedback message
 * @param {FeedbackValues} data
 * @return {AxiosResponse}
 */
export async function sendFeedback(data: FeedbackValues) {
  return axios({
    method: 'POST',
    url: `${process.env.REACT_APP_API_BASE_URL}/feedback`,
    data: JSON.stringify({
      email: data.email,
      subject: data.messageType,
      message: data.message,
    }),
  }).then((response: AxiosResponse) => {
    return response;
  }).catch((error: AxiosError<ErrorObject>) => (
    error.response?.data
  ));
}